<convfact-investment-financial-form [investmentFinancial]="investmentFinancial" [accounts]="accounts" (onSave)="saveData($event)">
</convfact-investment-financial-form>
